import { mergePlain } from 'util/merge'
import { doBulkUpdate } from './doBulkUpdate'
import { doDelete } from './doDelete'

export const doBulkDelete = (ticketIds, options = {}) => dispatch => {
  return dispatch(
    doBulkUpdate(
      ticketIds,
      doDelete,
      [],
      mergePlain(
        {
          moduleOptions: {
            snackbar: {
              enabled: true,
              success: {
                enabled: true,
                message: `${app.t('N_Tickets', {
                  count: ticketIds.length,
                })} deleted forever`,
              },
              failed: {
                enabled: true,
                message: "Oops, we couldn't delete your tickets.",
              },
            },
          },
        },
        options
      )
    )
  )
}
